/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";

import {
  ADD_STUDENTUNITTEST,
  GET_STUDENT_UNITPRETEST_BYFILTER,
  GENERATE_STUDENT_UNITPRETESTS,
  BULKCREATE_STUDENTUNIT_PRETEST_ANSWER,
  GET_STUDENT_UNITPOSTTEST_BYFILTER,
  GENERATE_STUDENT_UNITPOSTTESTS,
  BULKCREATE_STUDENTUNIT_POSTTEST_ANSWER,
  UPDATE_STUDENTUNIT_TEST
} from '@/queries/modules/student-unittest';

/**
  *  Action to Add Student Unittest
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export const addStudentUnitTest = async (context, payload) => {
  // context.commit('setProcessing', true);
  try {
    const result = await apolloClient
    .mutate({
      mutation: ADD_STUDENTUNITTEST,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await result;

    return data.addStudentUnitTest;

  } catch (e) {
    // console.log(e);
    // context.commit('setError', error(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
};

export const updateStudentUnitTest = async (context, payload) => {
  // context.commit('setProcessing', true);

  try {
    const response = await apolloClient
    .mutate({
      mutation: UPDATE_STUDENTUNIT_TEST,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await response;

    // Result is updated Student Unit Test
    return data.updateStudentUnitTest;


  } catch (e) {
    // console.log(e);
    // commit('setError', error(e));
    return null;
  }
};

/**
  *  Action to Get Student Unit Pretest (by Student Unit Test ID)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export const getStudentUnitPretests = async (context, payload) => {
  // context.commit('setProcessing', true);
  try {
    const response = await apolloClient
    .query({
      query: GET_STUDENT_UNITPRETEST_BYFILTER,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await response;

    return data.getStudentUnitPretestsByFilter;

  } catch (e) {
    // console.log(e);
    // commit('setError', error(e));
    return null;
  }
};

export const generateStudentUnitPretests = async (context, payload) => {
  // Request for Generating Student Unit Pretests
  try {
    const response = await apolloClient
      .mutate({
        mutation: GENERATE_STUDENT_UNITPRETESTS,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const { data } = await response;

    return data.generateStudentUnitPretests;

  } catch (e) {
    return null;
  }
};

/**
  *  Action to Bulkly Update Student Unit Pretest Answers (as an array)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export const bulkCreateStudentUnitPretestAnswer = async (context, payload) => {
  // context.commit('setProcessing', true);
  try {
    const result = await apolloClient
    .mutate({
      mutation: BULKCREATE_STUDENTUNIT_PRETEST_ANSWER,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await result;

    return data.bulkCreateStudentUnitPretestAnswer;

  } catch (e) {
    // console.log(e);
    // commit('setError', error(e));
    return null
  }
};


/**
  *  Action to Get Student Unit Posttest (by Student Unit Test ID)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export const getStudentUnitPosttests = async (context, payload) => {
  // context.commit('setProcessing', true);
  try {
    const response = await apolloClient
    .query({
      query: GET_STUDENT_UNITPOSTTEST_BYFILTER,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await response;

    return data.getStudentUnitPosttestsByFilter;

  } catch (e) {
    // console.log(e);
    // commit('setError', error(e));
    return null;
  }
};

export const generateStudentUnitPosttests = async (context, payload) => {
  // Request for Generating Student Unit Posttests
  try {
    const response = await apolloClient
      .mutate({
        mutation: GENERATE_STUDENT_UNITPOSTTESTS,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const { data } = await response;

    return data.generateStudentUnitPosttests;
  } catch (e) {
    return null;
  }
};

/**
  *  Action to Bulkly Update Student Unit Posttest Answers (as an array)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export const bulkCreateStudentUnitPosttestAnswer = async (context, payload) => {
  // context.commit('setProcessing', true);
  try {
    const result = await apolloClient
    .mutate({
      mutation: BULKCREATE_STUDENTUNIT_POSTTEST_ANSWER,
      variables: payload,
      context: { clientName: 'Prisma2' }
    })
    const { data } = await result;

    return data.bulkCreateStudentUnitPosttestAnswer;

  } catch (e) {
    // console.log(e);
    // commit('setError', error(e));
    return null;
  }
};
